// Voice-note helpers: turn a recorded Blob into base64 + duration + a downsampled waveform
// (0..100 peaks) so it can be sent via api.sendVoice and rendered as bars by MessageBubble.

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(String(fr.result).split(",")[1]); // strip the data: prefix
    fr.onerror = () => reject(new Error("read failed"));
    fr.readAsDataURL(blob);
  });
}

// Decode the audio and return { duration, wave } where wave has `bars` normalized peaks (0..100).
export async function analyzeAudio(blob, bars = 32) {
  try {
    const buf = await blob.arrayBuffer();
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ac = new Ctx();
    const audio = await ac.decodeAudioData(buf);
    const data = audio.getChannelData(0);
    const block = Math.floor(data.length / bars) || 1;
    const wave = [];
    for (let i = 0; i < bars; i += 1) {
      let peak = 0;
      for (let j = 0; j < block; j += 1) {
        const v = Math.abs(data[i * block + j] || 0);
        if (v > peak) peak = v;
      }
      wave.push(Math.round(Math.min(1, peak) * 100));
    }
    const duration = audio.duration;
    if (ac.close) ac.close();
    return { duration, wave };
  } catch {
    return { duration: 0, wave: [] };
  }
}
